import { proxy } from 'valtio';

type RendererState = {
  ready: boolean;
};

export const currentRendererState = proxy<RendererState>({
  ready: false,
});

export const setRendererReadyStatus = (status: boolean) =>
  (currentRendererState.ready = status);
